export const validationRules = {
  inputPath: {
    type: 'string',
    pattern: /^s3:\/\//,
    message: 'Input path must start with s3://',
  },
  s3Link: {
    type: 'string',
    pattern: /^s3:\/\//,
    message: 'S3 link must start with s3://',
  },
  outputPrefix: {
    type: 'string',
    pattern: /^[A-Za-z0-9_-]+$/,
    message:
      'Output Prefix can only contain letters, digits, underscores, and dashes (-).',
    required: false,
  },
  sampleId: {
    type: 'string',
    pattern: /^ST-\d{5}$/,
    message: 'Sample ID must start with "ST-" followed by 5 digits.',
    required: false,
  },
  slideId: {
    type: 'string',
    pattern: /^\d{3,5}[A-H]+$/,
    message: 'Slide ID must be 3-5 digits followed by one or more letters A-H.',
    required: false,
  },
  slideNumber: {
    type: 'string',
    pattern: /^\d{3,5}$/,
    message: 'Slide number must be a number of 3-5 digits',
    required: false,
  },
  keyword: {
    type: 'string',
    pattern: /^[A-Za-z0-9_-]+$/,
    message:
      'Keyword can only contain letters, digits, underscores, and dashes (-).',
    required: false,
  },
  includeKeywords: {
    type: 'string',
    pattern: /^[A-Za-z0-9_,]*$/,
    message:
      'Include keywords can only contain letters, numbers, commas and underscores.',
    required: false,
  },
  excludeKeywords: {
    type: 'string',
    pattern: /^[A-Za-z0-9_,]*$/,
    message:
      'Exclude keywords can only contain letters, numbers, commas and underscores.',
    required: false,
  },
  wells: {
    type: 'string',
    pattern: /^[A-H]{1,8}$/,
    custom: (value: string) => {
      const sorted = value.split('').sort().join('');
      return value === sorted
        ? undefined
        : 'Wells must be in alphabetical order (e.g. AB, CDH)';
    },
    required: false,
  },
};
